import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthProvider';
import { Skeleton } from '../components/ui';

export function ProtectedRoute() {
  const { session, loading, active } = useAuth();
  const location = useLocation();
  if (loading) return <div className="grid min-h-screen place-items-center bg-canvas"><Skeleton className="h-24 w-72" /></div>;
  if (!session) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (!active) return <Navigate to="/login" replace state={{ inactive: true }} />;
  return <Outlet />;
}

export function AdminRoute() {
  const { role, loading } = useAuth();
  if (loading) return <Skeleton className="h-64 w-full" />;
  if (role !== 'admin' && role !== 'superadmin' && role !== 'head') return <Navigate to="/app/dashboard" replace />;
  return <Outlet />;
}

export function PriceEditorRoute() {
  const { role, loading } = useAuth();
  if (loading) return <Skeleton className="h-64 w-full" />;
  if (role !== 'admin' && role !== 'superadmin') return <Navigate to="/app/dashboard" replace />;
  return <Outlet />;
}

export function AccountManagementRoute() {
  const { canManageAccounts, loading } = useAuth();
  if (loading) return <Skeleton className="h-64 w-full" />;
  if (!canManageAccounts) return <Navigate to="/app/dashboard" replace />;
  return <Outlet />;
}
